<template>
  <g-list class="margin-top" bordered>
    <g-list-item style="display: block">
      <g-row type="flex" justify="space-between">
        <g-column :span="20">
          <g-typography size="small" tag="div" font-weight="semibold" value="Type" />
        </g-column>
        <g-column :span="4">
          <g-typography size="small" tag="div" font-weight="semibold" value="Amount" />
        </g-column>
      </g-row>
    </g-list-item>
    <template v-if="!isTaskPayment">
      <g-list-item
        v-for="payment in brief.payment_configs"
        :key="payment.id"
        style="display: block"
      >
        <g-row type="flex" justify="space-between">
          <g-column :span="20">
            <g-typography size="h4" tag="div" :value="paymentLabel(payment)" />
          </g-column>
          <g-column :span="4">
            <g-typography :value="paymentString(payment)" />
          </g-column>
        </g-row>
      </g-list-item>
    </template>
    <template v-if="isTaskPayment">
      <g-list-item
        v-for="type in taskPaymentConfigs"
        :key="type.id"
        style="display: block"
      >
        <g-row type="flex" justify="space-between">
          <g-column :span="20">
            <g-level spacing="tiny">
              <g-level-item class="align-items-start">
                <span
                  v-if="isTikTok(type.task_type)"
                  class="gi gi-tiktok"
                  style="margin-right: 12px; color: #000"
                />
                <g-icon
                  v-else
                  :name="mapTaskIconName(type.task_type)"
                  :type="mapTaskIconType(type.task_type)"
                  color="brand"
                  style="margin-right: 12px; color: #252a30"
                />
              </g-level-item>

              <g-level-item class="align-items-start">
                <g-typography size="h4" tag="div" :value="taskLabel(type.task_type)" />
              </g-level-item>
            </g-level>
          </g-column>
          <g-column :span="4">
            <g-typography :value="paymentString(type)" />
          </g-column>
        </g-row>
      </g-list-item>
    </template>
  </g-list>
</template>

<script>
  import { PAYMENT_TYPE_LABEL } from '../../../../../constants/activation-payments';
  import { currencies } from '@grininc/grin-ui';
  import {
    NETWORK_INFO_MAP,
    NETWORK_LABEL_MAP,
    TYPE_TIKTOK_VIDEO
  } from '../../../../../constants/networks';

  export default {
    name: 'PaymentsList',
    props: {
      brief: {
        type: Object,
        required: true
      }
    },
    methods: {
      paymentLabel(payment) {
        return PAYMENT_TYPE_LABEL[payment.type];
      },
      paymentString(payment) {
        return currencies[payment.currency].symbol + payment.amount;
      },
      mapTaskIconType(type) {
        return NETWORK_INFO_MAP[type] ? 'brand' : 'solid';
      },
      mapTaskIconName(type) {
        const taskType = NETWORK_INFO_MAP[type];
        return taskType ? taskType.slug : 'star-of-life';
      },
      taskLabel(type) {
        return NETWORK_LABEL_MAP[type];
      },
      isTikTok(task_type) {
        return task_type === TYPE_TIKTOK_VIDEO;
      }
    },
    computed: {
      /**
       * If the brief has `contract_payments_mode` === 'per_task`, then we should only display the task amounts that pertain to the content tracking tasks
       */
      taskPaymentConfigs() {
        if (this.isTaskPayment) {
          return this.brief.payment_configs.filter((config) =>
            this.brief.tasks.some((task) => task.type === config.task_type)
          );
        }
      },
      isTaskPayment() {
        return this.brief.contract_payments_mode === 'per_task';
      }
    }
  };
</script>

<style lang="scss" scoped>
    .gi-tiktok {
        color: #000;
        width: 1.25em;
        display: inline-block;
        text-align: center;
        margin-right: 1em !important;
        height: 1.5rem;
    }
</style>